import moment from 'moment'
// 根据16进制颜色获取rgba
export function colorRgb(str, opacity) {
	var sColor = str.toLowerCase();
	if (sColor) {
		if (sColor.length === 4) {
			var sColorNew = "#";
			for (var i = 1; i < 4; i += 1) {
				sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
			}
			sColor = sColorNew;
		}
		//处理六位的颜色值
		var sColorChange = [];
		for (var i = 1; i < 7; i += 2) {
			sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
		}
		return "rgba(" + sColorChange.join(",") + "," + opacity + ")";
	} else {
		return sColor;
	}
};
// 字体自适应
export function selfAdaptionPX(res){
    let docEl = document.documentElement,
      clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let selfAdaption = 100 * (clientWidth / 1920);
    return res*selfAdaption;
   
  }

export function getFactoryId(){
	// var factoryId = JSON.parse(localStorage.getItem('userInfo'));
	var factoryId = localStorage.getItem("factoryInfo")
  	return factoryId
}
export function getParentFactoryId(){
	var parentFactoryId = JSON.parse(localStorage.getItem('userInfo'));
  	return parentFactoryId
}

export const nextyear = (date, diff = '9', time = 'years', format = "YYYY") => {
    //   time = 'years' days months weeks
    return moment(date)
        .subtract(diff, time)
        .format(format);
}